module.exports = __webpack_public_path__ + "pin_pink.e491c3.png";